<template>
  <div id="app">
    <loading :isShow="showOrNot" @nextPage="onNextPage" />
    <page-kv :isShow="showOrNot" @nextPage="onNextPage" />
    <page-one :isShow="showOrNot" @nextPage="onNextPage" />
    <page-two :isShow="showOrNot" @nextPage="onNextPage" />
    <page-three :isShow="showOrNot" @nextPage="onNextPage" />
    <page-four :isShow="showOrNot" @nextPage="onNextPage"></page-four>
    <page-five :isShow="showOrNot" @nextPage="onNextPage"></page-five>
    <music-player />
    <wx-share :shareTitle="title" :shareDesc="desc" :shareImg="thumbImg" :shareLink="link" />
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import Loading from './pages/loading/loading'
import PageKV from './pages/page-kv/pageKV'
import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'
import PageThree from './pages/page-three/pageThree'
import PageFour from './pages/page-four/pageFour'
import PageFive from './pages/page-five/pageFive'
import WxShare from './components/wxShare/wxShare';

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'page-three': PageThree,
    'page-four': PageFour,
    'page-five': PageFive,
    'wx-share': WxShare
  },
  data () {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isPHShow: false,
        isPFShow: false,
        isPVShow: false
      },
      title: '贵知贵行',
      desc: '贵州电网公司《2019企业文化年度报告》',
      thumbImg: 'https://www.jiandoukeji.com/h5/2020/southern-grid/common/thumb.jpg',
      link: ''
    }
  },
  methods: {
    onNextPage(para) {
      Object.keys(this.showOrNot).map(item => {
        this.showOrNot[item] = false
      })
      this.showOrNot[para] = true;
    }
  }
}
</script>

<style>
@import './assets/reset.less';
#app {
  width: 100%;
  height: 100%;
  min-width: 320px;
  max-width: 540px;
}
</style>
